import { Fragment } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import QuoteItem from './QuoteItem';
import classes from './QuoteList.module.css';

function sortQuotes(quotes, ascending) {
  return quotes.sort((quoteA, quoteB) => {
    if (ascending) {
      return quoteA.id < quoteB.id ? 1 : -1;
    } else {
      return quoteA.id > quoteB.id ? 1 : -1;
    }
  });
}

const QuoteList = (props) => {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const isSortingNewest = queryParams.get('sort') === 'newest-first';

  const sortedQuotes = sortQuotes(props.quotes, isSortingNewest);

  function handleChangeSort() {
    history.push(`${location.pathname}?sort=${!isSortingNewest ? 'newest-first' : 'oldest-first'}`);
  }

  return (
    <Fragment>
      <div className={classes.sorting}>
        <button onClick={handleChangeSort}>
        Sort: {isSortingNewest ? 'Newest First' : 'Oldest First'}</button>
      </div>
      <ul className={classes.list}>
        {sortedQuotes.map((quote) => (
          <QuoteItem
            key={quote.id}
            id={quote.id}
            author={quote.author}
            text={quote.text}
            category={quote.category}
          />
        ))}
      </ul>
    </Fragment>
  );
};

export default QuoteList;
